// src/components/TeamSelection.js
import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';

export default function TeamSelection() {
    const { updateUserData } = useAuth();
    const { t } = useLanguage();

    const handleTeamSelection = async (team) => {
        try {
            await updateUserData({ team });
        } catch (error) {
            console.error("Error selecting team:", error);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 flex items-center justify-center">
            <div className="bg-white p-8 rounded-lg shadow-2xl text-center">
                <h2 className="text-2xl font-bold mb-6 text-gray-800">{t('chooseTeam')}</h2>

                <div className="space-y-4">
                    <button
                      onClick={() => handleTeamSelection('blackWhite')}
                      className="w-full px-6 py-4 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors"
                    >
                        <div className="flex flex-col items-center">
                            <div className="flex items-center gap-2">
                                <span className="text-2xl">⚫⚪</span>
                                <span className="text-xl">{t('blackWhite')}</span>
                            </div>
                            <span className="text-lg mt-1">{t('blackWhiteTeam')}</span>
                        </div>
                    </button>

                    <button
                      onClick={() => handleTeamSelection('redWhite')}
                      className="w-full px-6 py-4 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                    >
                        <div className="flex flex-col items-center">
                            <div className="flex items-center gap-2">
                                <span className="text-2xl">🔴⚪</span>
                                <span className="text-xl">{t('redWhite')}</span>
                            </div>
                            <span className="text-lg mt-1">{t('redWhiteTeam')}</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
}